import Component from "@lib/Component.js";
import { observeOnce } from "@lib/helpers/observer";
import { addClass, removeClass } from "@qneyraud/q-utils/umd/q-utils";

export default class BaseImage extends Component {
  init() {
    super.init();
    this.bindMethods();
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    if (this.isLazyload) {
      observeOnce(this.el).on("enter", this.onImageEnter);
    }
  }

  bindMethods() {
    this.onImageEnter = this.onImageEnter.bind(this);
  }

  isLazyload() {
    return this.datas.lazyload === "true";
  }

  onImageEnter() {
    addClass(this.el, "loading");

    const img = new Image();

    img.onload = () => {
      removeClass(this.el, "loading");
      addClass(this.el, "loaded");
      this.refs.image.src = this.refs.image.dataset.src;
    };

    img.src = this.refs.image.dataset.src;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Image.js